import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BranchService } from 'src/app/services/branch.service';
import { CompanyService } from 'src/app/services/companyService';
import { StateCategoryService } from 'src/app/services/state-category.service';
import { UserDataService } from 'src/app/services/users.service';
import { UserSessionService } from 'src/app/services/user-session.service';

@Component({
  selector: 'app-request-list-search-dialog',
  templateUrl: './request-list-search-dialog.component.html',
})
export class RequestListSearchDialogComponent implements OnInit {

  form: FormGroup;

  operators: any[] = [];
  branches: any[] = [];
  companies: any[] = [];
  stateCategories: any[] = [];
  years: string[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RequestListSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private branchService: BranchService,
    private companyService: CompanyService,
    private stateCategoryService: StateCategoryService,
    private userDataService: UserDataService,
    private userSessionService: UserSessionService,
  ) {
    this.form = this.fb.group({
      text: [data?.text ?? ''],
      notes: [data?.notes ?? ''],
      assignmentOperator: [data?.rawSelections?.assignmentOperator ?? []],
      businessLineId: [data?.rawSelections?.businessLineId ?? []],
      companyId: [data?.rawSelections?.companyId ?? []],
      stateId: [data?.rawSelections?.stateId ?? []],
      year: [data?.rawSelections?.year ?? []],
      subjectName: [data?.subject?.name ?? ''],
      subjectSurname: [data?.subject?.surname ?? ''],
      subjectLegalEntity: [data?.subject?.legalEntity ?? ''],
      subjectEmail: [data?.subject?.email ?? ''],
      subjectTelephone1: [data?.subject?.telephone1 ?? ''],
      subjectTelephone2: [data?.subject?.telephone2 ?? ''],
      buildingStreetName: [data?.building?.streetName ?? ''],
      buildingStreetNumber: [data?.building?.streetNumber ?? ''],
      buildingZip: [data?.building?.zip ?? ''],
      buildingCity: [data?.building?.city ?? ''],
    });

    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= 2015; y--) {
      this.years.push(String(y));
    }
  }

  ngOnInit(): void {

    let user = this.userSessionService.getState('user');
    console.log(user.UsersCompaniesRel)

    // assignmentOperator è disabilitato finché non viene selezionata almeno una company
    this.form.get('assignmentOperator')?.disable();

    // Reagisce alle variazioni di companyId per caricare gli operatori
    this.form.get('companyId')?.valueChanges.subscribe((selectedCompanies: any[]) => {
      if (!selectedCompanies || selectedCompanies.length === 0) {
        this.form.get('assignmentOperator')?.disable();
        this.form.get('assignmentOperator')?.setValue([]);
        this.operators = [];
      } else {
        const codes = selectedCompanies.map((c: any) => c.code);
        this.userDataService.getByCompanyCode(codes).subscribe((comps: any[]) => {
          const opList: any[] = [];
          const users = comps.filter((usr: any) => usr.email !== null && usr.email !== undefined && usr.email.trim() !== '');
          users.forEach((element: any) => {
            element.UsersCompaniesRel.forEach((element2: any) => {
              if (codes.includes(element2.code)) {
                opList.push(element);
              }
            });
          });
          const operatorList = [...new Set(opList)];
          this.operators = operatorList.sort((a: any, b: any) => a.email <= b.email ? -1 : 1);
          this.form.get('assignmentOperator')?.enable();
          // Ripristina la selezione salvata degli operatori
          const saved: any[] = this.data?.rawSelections?.assignmentOperator ?? [];
          if (saved.length) {
            const matched = this.operators.filter(o => saved.some((s: any) => s.id === o.id));
            if (matched.length) this.form.patchValue({ assignmentOperator: matched });
          }
        });
      }
    });

    this.branchService.getAllBranches().subscribe((branches: any[]) => {
      this.branches = branches;
      const saved: any[] = this.data?.rawSelections?.businessLineId ?? [];
      if (saved.length) {
        const matched = this.branches.filter(b => saved.some((s: any) => s.id === b.id));
        if (matched.length) this.form.patchValue({ businessLineId: matched });
      }
    });

    this.companies = user.UsersCompaniesRel.sort((a: any, b: any) =>
      (a.code ?? '').toLowerCase() <= (b.code ?? '').toLowerCase() ? -1 : 1
    );
    // Il patchValue su companyId attiva la subscription valueChanges sopra,
    // che si occuperà anche di caricare gli operatori e ripristinare la selezione
    const savedCompanies: any[] = this.data?.rawSelections?.companyId ?? [];
    if (savedCompanies.length) {
      const matched = this.companies.filter((c: any) => savedCompanies.some((s: any) => s.id === c.id));
      if (matched.length) this.form.patchValue({ companyId: matched });
    }

    this.stateCategoryService.index().subscribe((categories: any[]) => {
      this.stateCategories = categories.filter(
        (sc: any) => sc.itemCategory?.code === 'item_categories_requests'
      );
      const saved: any[] = this.data?.rawSelections?.stateId ?? [];
      if (saved.length) {
        const matched = this.stateCategories.filter(sc => saved.some((s: any) => s.id === sc.id));
        if (matched.length) this.form.patchValue({ stateId: matched });
      }
    });
  }

  search(): void {
    const v = this.form.value;
    this.dialogRef.close({
      text: v.text,
      notes: v.notes,
      rawSelections: {
        assignmentOperator: v.assignmentOperator ?? [],
        businessLineId: v.businessLineId ?? [],
        companyId: v.companyId ?? [],
        stateId: v.stateId ?? [],
        year: v.year ?? [],
      },
      request: {
        assignmentOperator: (v.assignmentOperator ?? []).map((u: any) => u.email),
        businessLineId: (v.businessLineId ?? []).map((b: any) => b.id),
        companyId: (v.companyId ?? []).map((c: any) => c.id),
        stateId: (v.stateId ?? []).flatMap((sc: any) => (sc.states ?? []).map((s: any) => s.id)),
        year: v.year ?? [],
      },
      subject: {
        name: v.subjectName,
        surname: v.subjectSurname,
        legalEntity: v.subjectLegalEntity,
        email: v.subjectEmail,
        telephone1: v.subjectTelephone1,
        telephone2: v.subjectTelephone2,
      },
      building: {
        streetName: v.buildingStreetName,
        streetNumber: v.buildingStreetNumber,
        zip: v.buildingZip,
        city: v.buildingCity,
      },
    });
  }

  reset(): void {
    this.form.reset({
      text: '',
      notes: '',
      assignmentOperator: [],
      businessLineId: [],
      companyId: [],
      stateId: [],
      year: [],
      subjectName: '',
      subjectSurname: '',
      subjectLegalEntity: '',
      subjectEmail: '',
      subjectTelephone1: '',
      subjectTelephone2: '',
      buildingStreetName: '',
      buildingStreetNumber: '',
      buildingZip: '',
      buildingCity: '',
    });
    this.form.get('assignmentOperator')?.disable();
    this.operators = [];
  }

  removeSelection(field: string, item: any): void {
    const current: any[] = this.form.get(field)?.value ?? [];
    this.form.get(field)?.setValue(current.filter(i => i !== item));
  }

  clearField(field: string): void {
    this.form.get(field)?.setValue('');
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
